/**
 * Preslenmiş (compress) promo mozaik: mobilde genişleyince ok gizleniyordu ve tema JS
 * ikinci tıklamayı "link" için bırakıyordu. Ok görünür + ters chevron; ok ile daraltma.
 * Empire DynamicPromoBlocks ile aynı sınıflar / trend olayı.
 */
(function () {
  'use strict';

  function resetHeight($block) {
    var $wrapper = $block.find('.promo-block--content-wrapper');
    $block.css({ height: '' });
    $wrapper.css({ transform: '', top: '' });
  }

  function collapseContent(contentEl, $) {
    var $content = $(contentEl);
    $content
      .addClass('animating animating-out')
      .one('trend', function () {
        $content
          .removeClass('animating animating-out promo-block--expanded')
          .off('trend');
        contentEl.removeAttribute('data-clicked');
        resetHeight($content);
      });
  }

  function isCompressedMosaic(contentEl) {
    return !!contentEl.closest('.promo-mosaic--inner.promo-mosaic--compressed');
  }

  function isMobilePromoBreakpoint() {
    return window.matchMedia('(max-width: 719px)').matches;
  }

  function onDocumentClickCapture(e) {
    var expander = e.target.closest('.promo-block--expander');
    if (!expander) return;
    var content = expander.closest('[data-promo-block-content]');
    if (!content || !isCompressedMosaic(content)) return;
    if (!isMobilePromoBreakpoint()) return;
    if (!content.classList.contains('promo-block--expanded')) return;
    if (content.classList.contains('animating')) return;

    var $ = window.jQuery;
    if (!$) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    collapseContent(content, $);
  }

  function bind() {
    document.addEventListener('click', onDocumentClickCapture, true);
  }

  function waitForJquery() {
    if (typeof window.jQuery !== 'undefined') {
      bind();
      return;
    }
    setTimeout(waitForJquery, 30);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForJquery);
  } else {
    waitForJquery();
  }
})();
